/**
 * - Add flex 1 to catalogEntryListCompareCollectorPriceDescSX
 */

import { SxProps } from '@mui/material';

export const catalogEntryListCompareCollectorPriceDescSX: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	lineHeight: 1.25,
	flex: 1,
	minWidth: 0,
};
